import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { WorkflowJobState, WorkflowJobModel, WorkflowJobTabModel, JobTabStateModel, DynamicFormValidationModel, FieldModel, WorkflowJobPostProcessNavigationModel } from '@/types';

export const state: WorkflowJobState = {
  workflowJob: {} as WorkflowJobModel,
  isWorkflowJobLocked: false,
  isLoading: true,
  isDirty: false,
  error: false,
  errorMessage: '',
  activeHorizontalTab: {} as WorkflowJobTabModel,
  activeVerticalTab: {} as WorkflowJobTabModel,
  jobTabStates: [] as JobTabStateModel[],
  extendingLock: false,
  dynamicFormValidationModels: [] as DynamicFormValidationModel[],
  isAwaitingProcessing: false,
  dynamicFields: {} as FieldModel,
  postProcessNavigation: {} as WorkflowJobPostProcessNavigationModel,
  isTabProcessing: false,
  hasWorkflowJobBeenNavigatedAwayFrom : false,
  isWorkflowJobProcessed: false
};

const namespaced: boolean = true;

export const workflowJob = {
  namespaced,
  state,
  actions,
  getters,
  mutations
};
